/**
 * @module
 *
 * @import {Amateur} from "../../amateurPool/model/amateur";
 * @import {ErrorResponse} from '../../core/service/backend';
 */

import {user} from '../../user/user.js';
import {httpDelete, put} from '../../core/service/backend.js';
import {checkPin} from './cache.js';

/**
 * @param {Element} element
 * @param {Amateur} amateur
 *
 * @returns {Promise<void>}
 */
const toggle = async (element, amateur) => {
  const url = `pin/amateur/${amateur.id}`;
  /**
   * @param {ErrorResponse} error
   */
  const onError = async (error) => {
    if (error.httpStatus == 401) {
      user.guestSignup('pin.signupRequired', {nickname: amateur.getNickname()});

      return null;
    }

    throw error;
  };

  if (!checkPin(amateur)) {
    await put(url, {}, element, onError);
  } else {
    await httpDelete(url, element, onError);
  }
};

export {toggle as togglePin};
